import { auditLogsAPI } from '@/api';

const state = {
    filterOptions: {
        auditPoint: [],
        user: [],
        eventType: [],
    },
    filterOptionsLoading: false,
};

const mutations = {
    setAuditFilterOptions(state, payload) {
        state.filterOptions = payload;
    },
    setAuditFilterOptionsLoading(state, payload) {
        state.filterOptionsLoading = payload;
    },
};

const actions = {
    async getAllAuditLogs(_, params) {
        const response = await auditLogsAPI.getAuditLogsAPI(params);
        return { data: response.data._embedded['entries'], total: response.data['bz:total_records'] || 0 };
    },
    async getAuditLogById(_, id) {
        const response = await auditLogsAPI.getAuditLogByIdAPI(id);
        return response.data;
    },
    async downloadAuditLogs(_, params) {
        const response = await auditLogsAPI.downloadAuditLogsAPI(params);
        return response.data;
    },
    async getAuditFilterOptions({ commit }) {
        commit('setAuditFilterOptionsLoading', true);
        const response = await auditLogsAPI.getAuditFilterOptionsAPI();
        await commit('setAuditFilterOptionsLoading', false);
        commit('setAuditFilterOptions', response.data);
        return response.data;
    },
};

export default {
    state,
    mutations,
    actions,
};
